import { Typography, Input, Space } from "antd";
import {
  Table,
  Breadcrumb,
  Card,
  Button,
  Form,
  Pagination,
  Alert,
} from "react-bootstrap";
import { ExportToExcel } from "components/ExportToExcel";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Page from "components/Page";
import API, { baseUrl } from "utils/Axios";
import Policy from "components/Policy";
import {
  ROL_ADMIN,
  ROL_ASESOR,
  ROL_ESTUDIANTE,
  ROL_DOCENTE,
  ROL_PERSONA,
  PAGE_SIZE,
} from "constants/apiContants";
import Spin from "components/Spin";
import moment from "moment";
import { FaEye, FaArrowUp, FaCheck } from "react-icons/fa";
import MigaPanInicio from "components/MigaPan/Inicio";
import MigaPanAsesoriaJuridica from "components/MigaPan/AsesoriaJuridica";
import MigaPan from "components/MigaPan";
import { ACCESS_TOKEN_NAME } from "constants/apiContants";


const ResultadosEncuesta = () => {
    const [docs, setDocs] = useState([]);
    const [links, setLinks] = useState(null);
    const [paginacion, setPaginacion] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [params, setParams] = useState({ page_size: PAGE_SIZE, page: 1 });
    const [paramsSerialized, setParamsSerialized] = useState("")


    const getSolicitudes = async () => {
        setCargando(true);
        API.get(`asesorias/encuesta/`)
            .then(({ data }) => {
                setDocs(data.results || []);
                setPaginacion({ paginas: data.total_pages, registros: data.count });
                setLinks(data.links);
                setCargando(false);
                let u = new URLSearchParams(params).toString();
                setParamsSerialized(u)
            })
            .finally(() => setCargando(false));
    };
    const next = () => {
        const page = links.next.match(/page=[0-9]+/);
        console.log(page);
        setParams({ ...params, page: page[0].split("=")[1] });
    };
    const prev = () => {
        const text = links.previous.match(/page=[0-9]+/);
        const page = text ? text[0].split("=")[1] : 1;
        setParams({ ...params, page });
    };
    const calcularPaginas = () => {
        if (paginacion && docs.length) {
            let startPage, endPage;
            if (paginacion.paginas <= 10) {
                startPage = 1;
                endPage = paginacion.paginas;
            } else {
                if (params.page <= 6) {
                    startPage = 1;
                    endPage = 10;
                } else if (params.page + 4 >= paginacion.paginas) {
                    startPage = paginacion.paginas - 9;
                    endPage = paginacion.paginas;
                } else {
                    startPage = params.page - 5;
                    endPage = params.page + 4;
                }
            }
            const paginas = [];
            console.log(startPage, endPage);
            for (let i = startPage; i <= endPage; i++) {
                paginas.push(i);
            }
            return paginas.map((i) => {
                const p = { active: i == params.page };
                if (!p.active) {
                    p.onClick = () => {
                        setParams({ ...params, page: i });
                    };
                }
                return <Pagination.Item {...p}>{i}</Pagination.Item>;
            });
        }
    };

    useEffect(() => {
        getSolicitudes();
    }, []);

    return (
        <Policy
          policy={[ROL_ADMIN, ROL_ASESOR, ROL_DOCENTE, ROL_ESTUDIANTE, ROL_PERSONA]}
        >
          <Spin cargando={cargando}>
            <Page>
              <MigaPan>
                <MigaPanInicio />
                <span>Resultados de encuesta</span>
              </MigaPan>
              <Card>
                <Card.Body style={{overflow: 'scroll'}}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>No. registro</th>
                        <th>Nombres y apellidos</th>
                        <th>Registro en sistema</th>
                      </tr>
                    </thead>
                    <tbody>
                        {docs.map((d, i) => (
                            <tr key={i}>
                                <td>{d.id} </td>
                                <td>{d.usuario_nombres}</td>
                                <td>{d.sys_fechaCreacion}</td>
                            </tr>
                        ))}
                    </tbody>
                  </Table>
    
                  <div className="d-flex justify-content-center">
                    <Link to="/" className="mr-4">
                      Volver al inicio
                    </Link>
                  </div>
                </Card.Body>
                <Card.Footer className="d-flex justify-content-between">
                  <Form.Group className="d-flex align-items-center">
                    <Form.Label>Número de registros</Form.Label>&nbsp;
                    <Form.Control
                      as="select"
                      style={{ width: 150 }}
                      onChange={(e) =>
                        setParams({
                          ...params,
                          page: 1,
                          page_size: e.target.value,
                        })
                      }
                    >
                      <option value={10} selected={params.page_size == 10}>
                        10
                      </option>
                      <option value={50} selected={params.page_size == 50}>
                        50
                      </option>
                      <option value={100} selected={params.page_size == 100}>
                        100
                      </option>
                      <option value={500} selected={params.page_size == 500}>
                        500
                      </option>
                    </Form.Control>
                  </Form.Group>
                  <Pagination>
                    {links && links.previous ? (
                      <Pagination.Prev onClick={prev} />
                    ) : (
                      <Pagination.Prev disabled />
                    )}
                    {calcularPaginas()}
                    {links && links.next ? (
                      <Pagination.Next onClick={next} />
                    ) : (
                      <Pagination.Next disabled />
                    )}
                  </Pagination>
                  {docs.length > 0 ? (
                      <Button
                        variant="success"
                        size="sm"
                        // onClick={() => exportToExcel()}
                      >
                        Exportar a Excel
                      </Button>
                  ) : null}
                </Card.Footer>
              </Card>
            </Page>
          </Spin>
        </Policy>
      );
};

export default ResultadosEncuesta;
